import {
    Component,
    Input,
    OnInit,
    ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';

import { QuickPanelComponent } from '../../quick-panel/quick-panel.component';


@Component({
    selector: 'quick-panel-dynamic',
    templateUrl: './quick-panel-dynamic.component.html',
    styleUrls: ['./quick-panel-dynamic.component.scss']
})

export class QuickPanelComponentDynamic implements OnInit {
    @Input() public RefQuickPanelComponent : any;
        
    constructor(private vcr : ViewContainerRef, private cfr : ComponentFactoryResolver) {
        
    }

    ngOnInit(){
        if(this.RefQuickPanelComponent){
            this.vcr.createComponent(this.RefQuickPanelComponent);
        }else{
            let myComp = this.cfr.resolveComponentFactory(QuickPanelComponent);
            this.vcr.clear();
            this.vcr.createComponent(myComp);
        }
    }
}
